import React, { useEffect, useRef, useState } from 'react';
import { icons } from '../../../configs/Icons';
import { CamelCaseToHyphen } from '../../utils/TextFormatter';
import cn from '../../utils/cn';

function Items({ options, selectData, handleSelect }) {
    return (
        <ul className="w-full absolute top-full left-0 bg-white rounded-10 shadow-2xl border border-primary-200 z-[99999999] overflow-hidden">
            {options?.map((option) => (
                <li
                    key={option?.id}
                    className="w-full h-8 md:h-10 flex flex-row items-center justify-start gap-x-2 hover:bg-primary-100"
                >
                    <label
                        htmlFor={option?.id}
                        className="size-full flex items-center justify-start gap-2  px-3 "
                    >
                        <input
                            type="checkbox"
                            id={option?.id}
                            checked={!!selectData.find((el) => el.id === option.id)}
                            onChange={(e) => handleSelect(e, option)}
                        />
                        <span className="line-clamp-1">{option?.title}</span>
                    </label>
                </li>
            ))}
        </ul>
    );
}

export function getParamsAr(type) {
    if (type === null) return [];

    if (type.length === 0) return [];
    return type.split(',');
}

const cTypeExisted = (cType, options) => {
    if (cType === null || cType === undefined) return [];
    if (cType?.length === 0) return [];

    const newArr = options?.filter((el) => cType?.includes(el?.id.toString()));
    return newArr;
};
function SelectWithCheck({
    title,
    name,
    onChange,
    formData,
    options = [], // option is an array of objects, each object has 2 keys: key and title
    className = ''
}) {
    const [isShow, setIsShow] = useState(false);
    const ref = useRef(null);
    const selectData = cTypeExisted(formData[CamelCaseToHyphen(name)], options);
    const handleShowHide = () => {
        setIsShow((d) => !d);
    };
    // -- Click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref?.current && !ref?.current?.contains(e.target)) {
                setIsShow(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // -- End
    const handleSelect = (e, item) => {
        const cuData = [...selectData];

        if (e.target.checked) {
            cuData?.push(item);
        } else {
            const index = cuData.findIndex((el) => el.id === item.id);
            cuData?.splice(index, 1);
        }
        onChange({
            target: {
                name: CamelCaseToHyphen(name),
                value: cuData?.map((el) => el.value).join(',')
            }
        });
    };

    return (
        <div
            className={cn(
                `border border-primary-100 rounded-lg text-primary text-sm leading-6 font-normal capitalize flex flex-row justify-between items-center cursor-default select-none relative w-auto h-8 md:h-10`,
                className,
                {
                    'overflow-hidden': !isShow
                }
            )}
            ref={ref}
        >
            {selectData?.length === 0 ? (
                <div
                    role="button"
                    tabIndex={-1}
                    onClick={handleShowHide}
                    className="w-full h-full flex items-center justify-between p-2"
                >
                    <span className="line-clamp-1">Select {title}</span>
                    <img src={icons.downArrowV2W} alt="" />
                </div>
            ) : (
                <div
                    role="button"
                    tabIndex={-1}
                    onClick={handleShowHide}
                    className="w-full h-full flex items-center justify-start p-2 overflow-x-auto overflow-y-hidden scrollbar scrollbar-h-0 outline-none"
                >
                    {selectData?.map((item, index) => {
                        // if selectData length equal or less than 2 then show all  but selectData length equal or  greater than 2 then show 1 item and +2
                        if (selectData?.length <= 2) {
                            return (
                                <span key={item?.id} className="text-primary line-clamp-1">
                                    {index === 0 ? '' : ', '}
                                    {item?.title}
                                </span>
                            );
                        }
                        if (selectData?.length > 2) {
                            if (selectData.indexOf(item) === 0) {
                                return (
                                    <span key={item?.id} className="text-primary line-clamp-1">
                                        {`${item?.title} +${selectData.length - 1}`}
                                    </span>
                                );
                            }
                        }
                        return null;
                    })}
                </div>
            )}

            {isShow && (
                <Items options={options} selectData={selectData} handleSelect={handleSelect} />
            )}
        </div>
    );
}

export default SelectWithCheck;
